'use client';
import React from 'react';
import { CarouselPostProps } from './carousel-posts.props';
import PostItemDesktop from '../post-item/desktop';
import { Slider } from '@pezeshk-book/modules';

const CarouselPosts = ({ slides = 6, tabletSlides = 5, mobileSlides = 3, rows = 1, items }: CarouselPostProps) => {
  return (
    <Slider rows={rows} slides={slides} mobileSlides={mobileSlides} tabletSlides={tabletSlides} infiniteLoop={true}>
      {items && items?.length > 0 && items.map((postItem: any, index: any) => (
        <PostItemDesktop
          key={`postItemBlog_${index}`}
          title={postItem?.title}
          image={postItem?.image?.key_0?.url}
          subtitle={postItem?.title}
          slug={postItem?.slug}
          publishedAt={postItem?.published_at}
        />
      ))}
    </Slider>
  );
};

export default CarouselPosts;
